var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJjIconStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_519_507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.00016 14.6666V11.3333M3.00016 4.66665V1.33331M1.3335 2.99998H4.66683M1.3335 13H4.66683M8.66683 1.99998L7.51071 5.00589C7.3227 5.49471 7.2287 5.73912 7.08252 5.9447C6.95296 6.12691 6.79376 6.28611 6.61155 6.41567C6.40597 6.56185 6.16156 6.65585 5.67274 6.84386L2.66683 7.99998L5.67274 9.1561C6.16156 9.34411 6.40597 9.43811 6.61155 9.58429C6.79376 9.71385 6.95296 9.87305 7.08252 10.0553C7.2287 10.2608 7.3227 10.5053 7.51071 10.9941L8.66683 14L9.82295 10.9941C10.011 10.5053 10.105 10.2608 10.2511 10.0553C10.3807 9.87305 10.5399 9.71385 10.7221 9.58429C10.9277 9.43811 11.1721 9.34411 11.6609 9.1561L14.6668 7.99998L11.6609 6.84386C11.1721 6.65585 10.9277 6.56185 10.7221 6.41567C10.5399 6.28611 10.3807 6.12691 10.2511 5.9447C10.105 5.73912 10.011 5.49471 9.82295 5.00589L8.66683 1.99998Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_519_507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJjIconStarIcon);
export default __webpack_public_path__ + "static/media/JJ_Icon_Star_icon.ff53c9feb34a33b78dd15f73949d5b1c.svg";
export { ForwardRef as ReactComponent };